import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { environment } from "../../environments/environment"
import { ApiService } from "./api.service";
import { SearchResult } from "../models/search-result.model";
import { PetModel } from "../models/pet.model";
import { PetNoteModel, NoteModel, LoadTestModel, LabNameModel } from "../models/pet-note.model";
import { PetBriefModel } from "../models/pet-brief.model";
import { PetDiagnosisModel } from "../models/pet-diagnosis.model";
import { PetVisitModel } from "../models/pet-visit.model";
import { PetProfileModel } from "../models/pet-profile.model";
import { PetReferModel } from "../models/pet-refer.model";
import { PetProcsModel } from "../models/pet-proc.model";
import { RecallModel } from "../models/recall.model";
import { ClientService } from "./client.service";
import { GenericEstimateDetailModel } from "../models/generic-estimate.model";
import { EstimateDefModel, EstimateModel } from "../models/estimate.model";
import { PetEnvironmentModel } from "../models/pet-enviroment.model";
import { PetTagModel } from "../models/pet-tag.model";
import { PetAssociateModel } from "../models/pet-associate.model";
import { PetFullReferModel } from "../models/pet-full-refer.model";
import { HistoriesModel, HistoryModel, PrescriptionsModel, SuggestionsModel } from "../models/history.model";
import { SubHistoryModel } from "../models/subhistory.model";
import { PetMatabolicModel } from "../models/pet-metabolic.model";
import { PetVitalsModel } from "../models/pet-vitals.model";
import { ToothProblemModel } from "../models/tooth-problem.model";
import { PetDentalModel } from "../models/pet-dental.model";
import { CheckPetSexSpecieModel } from "../models/check-pet-sex-specie.model";
import { ProcCostModel } from "../models/proc-cost.model";
import { PetPatientModel } from "../models/pet-patient.model";
import { PetDetailModel } from "../models/pet-detail.model";
import { PetHistoryModel } from "../models/pet-history.model";
import { PetProblemModel } from "../models/pet-problem.model";
import { PetProfileLastEntryModel } from "../models/pet-profile-lastentry.model";
import { CurrentUserModel } from "../models/current-user.model";
import { PetTagListModel } from "../models/pet-tag-list.model";
import { LoadDocumentModel } from "../models/load-document.model";
import { AdmittedPetsModel } from "../models/admitted-pets.model";
import { PetTagHistModel } from "../models/pet-tag-hist.model";
import { resolve } from "dns";
import { GenericEstimateModel } from "../models/generic-estimate.model";
import { FileItemModel } from "../models/file-item.model";
import { PetTreatmentPlanModel } from "../models/treatment.model";
import { GalleryPicturesModel } from "../models/gallery-pictures.model";
import { FileModel } from "../models/file.model";
import { LabRecordModel } from "../models/lab-record.model";
import { switchMap, takeUntil } from 'rxjs/operators';
import { PetRabieDetailsModel } from "../models/pet-rabie-details.model";
import { PetExtraDataModel } from "../models/pet-extra-data.model";
import { PetRabieModel } from "../models/pet-rabie.model";



@Injectable({
    providedIn: "root"
})
export class PetService {

    private baseUrl: string = 'pet';
    private baseUrl2: string = 'client';
    current_pet_no: number = 0;
    soap = false;

    recall_date_begin = '';
    recall_date_end = '';

    private messagePetSource = new BehaviorSubject<number>(0);
    changePet = this.messagePetSource.asObservable();

    private messageGenericSource = new BehaviorSubject<boolean>(false);
    selectedGeneric = this.messageGenericSource.asObservable();

    private messageGenericSourceQuick = new BehaviorSubject<boolean>(false);
    selectedQuick = this.messageGenericSourceQuick.asObservable();

    private messageGenericSourceNotes = new BehaviorSubject<boolean>(false);
    selectedNotes = this.messageGenericSourceNotes.asObservable();

    histories_page_number: number = 1;
    histories_order: number = 2;
    notes_order: number = 2;
    search_begin: string = ''
    search_end: string = ''
    prescription_order: number = 2;
    view_physical = false;

    pet: PetModel = new PetModel(0, 0, '', '', 0, '', '', '', '', '', 0, 0, '', '', '', '', '', 0, 0, 0, '', false, 0, '', '', '', '', 0,0,'',0,'',false);
    pets: PetModel[] = [];
    simple_pet_list: {pet_no: number, pet_name: string, client_no: number}[] = [];
    pet_notes: PetNoteModel[] = [];
    pet_briefs: PetBriefModel[] = [];
    pet_diagnosis: PetDiagnosisModel[] = [];
    pet_problems: PetProblemModel[] = [];
    pet_procs: PetProcsModel[] = [];
    pet_recalls: RecallModel[] = [];
    pet_estimates: EstimateModel[] = [];
    pet_generic_estimates: EstimateModel[] = [];
    pet_profile_weight: PetProfileModel[] = [];
    pet_profile_temp: PetProfileModel[] = [];
    pet_profile_hr: PetProfileModel[] = [];
    pet_profile_height: PetProfileModel[] = [];
    pet_profile_fr: PetProfileModel[] = [];
    pet_profile_hydration: PetProfileModel[] = [];
    pet_profile_co2: PetProfileModel[] = [];
    pet_profile_bcs: PetProfileModel[] = [];
    pet_profile_bp: PetProfileModel[] = [];
    pet_profile_resp: PetProfileModel[] = [];
    pet_associates: PetAssociateModel[] = [];
    pet_histories: HistoryModel[] = [];
    pet_histories_filter: HistoryModel[] = [];
    pet_prescriptions_filter: PrescriptionsModel[] = [];
    pet_subhistories: SubHistoryModel[] = [];
    pet_suggestions: SuggestionsModel[] = [];
    pet_prescriptions: PrescriptionsModel[] = [];
    // pet_tooths: ToothProblemModel[] = [];
    pet_note: PetNoteModel = new PetNoteModel(0, '', 0, 0, '', '', '');
    pet_visit: PetVisitModel = new PetVisitModel(0, '', '', '', '', '', '', '', '');
    pet_visit2: PetVisitModel = new PetVisitModel(0, '', '', '', '', '', '', '', '');
    pet_profile: PetProfileModel[] = [new PetProfileModel(0, 0, 0, '1', '', 0), new PetProfileModel(0, 0, 0, '2', '', 0), new PetProfileModel(0, 0, 0, '3', '', 0), new PetProfileModel(0, 0, 0, '5', '', 0), new PetProfileModel(0, 0, 0, '36', '', 0)];
    pet_notes_checkin: PetNoteModel[] = [new PetNoteModel(0, '', 0, 0, '', '', ''), new PetNoteModel(0, '', 0, 0, '', '', ''), new PetNoteModel(0, '', 0, 0, '', '', '')];
    pet_refer: PetReferModel = new PetReferModel(0, '', '', '', 0);
    pet_proc: PetProcsModel = new PetProcsModel(0, 0, 0, 0, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 0, 0, '', '', 0, 0, '', '', '', '', 0, 0, false,0,0,0,'',0,0,'', 0,'',[]);
    pet_info_specie: any;
    pet_recall: RecallModel = new RecallModel(0, 0, 0, '', '', '', '', '', '', '', '', '', '', false, '', '', 0, 0, '', '', '', '', '', '', 0, [],'','Pending','', false);
    pet_estimate: EstimateModel = new EstimateModel(0, 0, '', '', 0, '', []);
    pet_tag: PetTagModel = new PetTagModel(0, 0, '', '', '', '');
    pet_associate: PetAssociateModel = new PetAssociateModel(0, '', '', '', 0, 0, '', 0);
    pet_fullrefer: PetFullReferModel = new PetFullReferModel(0, '', '', '', '', '', '');
    pet_metabolic: PetMatabolicModel = new PetMatabolicModel(0, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
    pet_environment: PetEnvironmentModel = new PetEnvironmentModel(0, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
    pet_vitals: PetVitalsModel = new PetVitalsModel(0, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '','','','','','');
    pet_tooth: ToothProblemModel = new ToothProblemModel(0, '', '', '', '', '', '', '');
    pet_dental: PetDentalModel = new PetDentalModel(0, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', []);
    pet_brief: PetBriefModel = new PetBriefModel(0, 0, 0, '', '', '', '', '', 0, false,'');
    pet_problem: PetProblemModel = new PetProblemModel(0, 0, 0, '', '', 0, '',0);
    pet_patient: PetPatientModel[] = [];
    pet_patientsingle: PetPatientModel = new PetPatientModel('', '', '', '', '', '', '', '', '', '','','','');
    pet_detail: PetDetailModel = new PetDetailModel(0, 0, '', 0, '', '', '', '', '', 0, 0, '', '', '', '', '', 0, 0, 0, 0, false, 0, '', '', '', '');
    searchPetFrom: string = '';
    pet_profile_lastentry: PetProfileLastEntryModel = new PetProfileLastEntryModel(0, '', 0, '', 0, '');
    pet_tag_list: PetTagListModel[] = [];
    admitted_pets: AdmittedPetsModel[] = [];
    pet_tag_hist: PetTagHistModel[] = [];
    pet_estimate_generic: EstimateModel = new EstimateModel(0, 0, '', '', 0, '', []);
    generic_estimates: GenericEstimateModel[] = [];
    pet_refer_by: PetReferModel = new PetReferModel(0, '', '', '', 0); 
    pet_treatment_plan: PetTreatmentPlanModel[] = [];
    note: NoteModel = new NoteModel(0, 0, '', '', '', [], false);
    notes: NoteModel[] = [];
    lab_test = [];
    lab_name: LabNameModel[] = [];
    load_test: LoadTestModel[] = [];
    gallery_pictures: GalleryPicturesModel[] = [];
    file_listing: FileModel[] = [];
    labrecord_listing: LabRecordModel[] = [];
    labrecord_tables: {test_code: string,table :LabRecordModel[]}[] = [];
    pet_teeth: {puppy: boolean, kitten: boolean, dog: boolean, cat: boolean} = {puppy: false, kitten: false, dog: false, cat: false};
    pet_rabie_details: PetRabieDetailsModel = new PetRabieDetailsModel(0,'','','','',0,0,'','','','','','',false,'');
    pettaghist_data: PetTagHistModel = new PetTagHistModel(0,'',0,'',0,'','','',0,0,'','','');
    pet_extra_data: PetExtraDataModel = new PetExtraDataModel(0,0,'',0,'',0,'',0,'','','','','','','');

    // userData: any = JSON.parse(localStorage['currentUser']);
    // current_client_no = localStorage['current_client_no'];
    total_recalls: number;
    op_type: number = 0;
    profile_type: number = 0;
    createNewPetOrigin = '';



    // Add a Subject to cancel previous requests
    public cancelHistoryRequests = new Subject<void>();

    

    constructor(
        private api: ApiService,
        private clientService: ClientService
    ) {

    }

    changePetVar(message: number) {
        this.messagePetSource.next(message)
        this.current_pet_no = message;
    }

    selectedGenericVar(message: boolean) {
        this.messageGenericSource.next(message)
    }

    selectedGenericQuick(message: boolean) {
        this.messageGenericSourceQuick.next(message)
    }

    selectedGenericNotes(message: boolean) {
        this.messageGenericSourceNotes.next(message)
    }

    private notify_PetStat = new Subject<void>();
    notify_PetStatObservable = this.notify_PetStat.asObservable(); 
    notify_PetStatFunction() { 
        this.notify_PetStat.next();
    }

    private notify_DrNurse = new Subject<void>();
    notify_DrNurseObservable = this.notify_DrNurse.asObservable(); 
    notify_DrNurseFunction() { 
        this.notify_DrNurse.next();
    }

    private notifyWorkPage = new Subject<void>();
    notifyWorkPageObservable = this.notifyWorkPage.asObservable(); 
    notifyWorkPageFunction() { 
        	this.notifyWorkPage.next();
    }

    setuptag_data:{id: number, tag_no: string, pet_no: number, pet_name: string, location: string, sublocation: number, duration: number, date: string, status: string, department: string} = {id: 0, tag_no: '', pet_no: 0, pet_name: '', location: '', sublocation: 0, duration: 0, date: '', status: '', department: ''};
    private notifySetupTag = new Subject<void>();
    notifySetupTagObservable = this.notifySetupTag.asObservable(); 
    notifySetupTagFunction() { 
        this.notifySetupTag.next();
    }

    private notifyUpdateTags = new Subject<void>();
    notifyUpdateTagsObservable = this.notifyUpdateTags.asObservable(); 
    notifyUpdateTagsFunction() { 
        this.notifyUpdateTags.next();
    }

    private notifyOpenFiles = new Subject<void>();
    notifyOpenFilesObservable = this.notifyOpenFiles.asObservable(); 
    notifyOpenFilesFunction() { 
        this.notifyOpenFiles.next();
    }

    private notifyLabRec = new Subject<void>();
    notifyLabRecObservable = this.notifyLabRec.asObservable(); 
    notifyLabRecFunction() { 
        this.notifyLabRec.next();
    }

    private ProcedureSubject = new Subject<{ pr_code: any; pr_status: any }>();
    ProcedureObservable = this.ProcedureSubject.asObservable(); 
    triggerProcedure(pr_code: any, pr_status: any) {
        this.ProcedureSubject.next({ pr_code, pr_status });
    }

    private notify_RecallUpdated = new Subject<void>();
    notify_RecallUpdatedObservable = this.notify_RecallUpdated.asObservable(); 
    notify_RecallUpdatedFunction() { 
        this.notify_RecallUpdated.next();
    }

    get userData(): any {
        return JSON.parse(localStorage.getItem('currentUser') || '{}');
    }
    
    get current_client_no(): any {
        return localStorage['current_client_no'];
    }

    getPetsByClient(client_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getPetsByClient?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pets = res.data.map((element) => {
                            return new PetModel(element.pet_no, client_no, '', element.pet_name, element.weight, element.sex, element.dob, element.neuter, element.rabieDate, element.active, element.temperature, element.height, element.pet_code, element.picture, element.breed_name, element.color_name, element.specie_name, element.breed, element.color, element.specie, element.tag_no, false, element.age, element.blood_pressure, element.rabies, element.chip_no, element.assigned_doctor, element.body_score,element.alt_breed, element.alt_breed_name,element.alt_color, element.alt_color_name,element.deceased);
                        });
                        resolve(1);
                    } else {
                        this.pets = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getNotesByPetId(pet_no: number, client_no: number = 0) {
        this.pet_notes = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getNotesByPetId?pet_no=${pet_no}&client_no=${client_no}&order=${this.notes_order}&search_begin=${this.search_begin}&search_end=${this.search_end}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_notes = res.data.map((element) => {
                            return new PetNoteModel(element.note_sequence, element.pet_name, element.pet_no, element.note_type, element.note_text, element.type_desc, element.note_date, element.table, element.editable);
                        });
                        resolve(1);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPetExtraData(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getPetExtraData?pet_no=${pet_no}&clinic_no=${this.userData.clinic_no}`)
                .subscribe((res: any) => {  
                    this.pet_extra_data = new PetExtraDataModel(res.vAmount, res.vTaxAmt, res.note_text, res.body_score, res.body_score_date, res.weight, res.weight_date, res.temp, res.temp_date, res.tag_no, res.location, res.sublocation, res.department, res.done_by, res.image_bidata);
                    this.pet_extra_data.vPetBal = res.vPetBal ?? null;
                    this.pet_profile_lastentry = new PetProfileLastEntryModel(res.body_score, res.body_score_date, res.weight, res.weight_date, res.temp, res.temp_date);
                    resolve(this.pet_extra_data); 
                });
        });
        return promise;
    }

    creupPetNote() {
        this.pet_note.pet_no = this.current_pet_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupPetNote`, this.pet_note)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetNoteByType() {
        this.pet_note.pet_no = this.current_pet_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetNoteByType`, this.pet_note)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deletePetNote(note_sequence) {
        this.pet_note.pet_no = this.current_pet_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletePetNote?note_sequence=${note_sequence}&table=tblNote`)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    reasignPetNote(pet_note) {
        this.pet_note.pet_no = this.current_pet_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/reasignPetNote`, pet_note)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetNoteBySOAP(pet_note: PetNoteModel) {
        this.pet_note.pet_no = this.current_pet_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetNoteByType`, pet_note)
                .subscribe((res: any) => {
                    if (res) {
                        resolve(res);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetNoteType(pet_note: PetNoteModel) {
        this.pet_note.pet_no = this.current_pet_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetNoteType`, pet_note)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getBriefByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getBriefByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_briefs = res.data.map((element) => {
                            return new PetBriefModel(element.brief_hist_sequence, element.client_no, element.pet_no, element.brief_hist_category, element.brief_hist_code, element.brief_hist_date, element.brief_hist_resp1, element.brief_hist_resp2, element.done_in_clinic, false, element.brief_due_date);
                        });
                        resolve(1);
                    } else {
                        this.pet_briefs = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProblemByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getProblemByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_problems = res.data.map((element) => {
                            return new PetProblemModel(element.problem_no, element.pet_no, element.diagnosisId, element.start_date, element.last_send_date, element.status, element.datedesc, element.noteseqno, element.PreferredTerm, element.OtherTerm, element.ModuleID, element.EffectiveTime);//D.PreferredTerm, D.OtherTerm, D.ModuleId, D.EffectiveTime
                        });
                        resolve(1);
                    } else {
                        this.pet_problems = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetProblem() {
        this.pet_recall.pet_no = this.current_pet_no;
        this.pet_recall.client_no = this.clientService.current_client_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetProblem`, this.pet_problem)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_problem = new PetProblemModel(0, 0, 0, '', '', 0, '',0);
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deletePetProblem(pet_problem) {
        this.pet_recall.pet_no = this.current_pet_no;
        this.pet_recall.client_no = this.clientService.current_client_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletePetProblem`, pet_problem)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_problem = new PetProblemModel(0, 0, 0, '', '', 0, '',0);
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    updatePetProblem(pet_problem) { 
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdatePetProblem?problem_no=${pet_problem.problem_no}&status=2&done_by=${this.userData.employee_name}`)
                .subscribe((res: any) => {
                    if (res && res.data) { 
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getDiagnosisByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getDiagnosisByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_diagnosis = res.data.map((element) => {
                            return new PetDiagnosisModel(element.pet_no, element.old_diagnosis, element.new_diagnosis, element.modified_date, element.modified_by);
                        });
                        resolve(1);
                    } else {
                        this.pet_diagnosis = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPetCheckIn(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getPetCheckIn?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_visit = new PetVisitModel(res.data.pet_visit.pet_no, res.data.pet_visit.discharge_time, res.data.pet_visit.discharge_time_extra, res.data.pet_visit.assigned_doctor, res.data.pet_visit.supervising_doctor, res.data.pet_visit.clinic_dept, res.data.pet_visit.invoice_limit, res.data.pet_visit.assigned_nurse1, res.data.pet_visit.assigned_nurse2, res.data.pet_visit.assigned_doctor_name, res.data.pet_visit.supervising_doctor_name, res.data.pet_visit.assigned_nurse1_name, res.data.pet_visit.assigned_nurse2_name);
                        this.pet_refer = new PetReferModel(res.data.pet_refer.pet_no, res.data.pet_refer.refer_doctor, res.data.pet_refer.refer_hospital, res.data.pet_refer.refer_date, res.data.pet_refer.refer_type);
                        this.pet_refer_by = new PetReferModel(res.data.pet_refer.pet_no, res.data.pet_refer.refer_doctor, res.data.pet_refer.refer_hospital, res.data.pet_refer.refer_date, res.data.pet_refer.refer_type);
                        this.pet_profile = res.data.pet_profile.map((element) => {
                            return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                        });

                        if (res.data.pet_notes_checkin) {
                            res.data.pet_notes_checkin.forEach((element) => {
                                if (element.note_type == 20) {
                                    this.pet_notes_checkin[0] = new PetNoteModel(element.note_sequence, element.pet_name, element.pet_no, element.note_type, element.note_text, element.type_desc, element.note_date);
                                }
                                else if (element.note_type == 21) {
                                    this.pet_notes_checkin[1] = new PetNoteModel(element.note_sequence, element.pet_name, element.pet_no, element.note_type, element.note_text, element.type_desc, element.note_date);
                                }
                                else if (element.note_type == 23) {
                                    this.pet_notes_checkin[2] = new PetNoteModel(element.note_sequence, element.pet_name, element.pet_no, element.note_type, element.note_text, element.type_desc, element.note_date);
                                }
                            });
                        }
                        resolve(1);
                    } else {
                        this.pet_notes_checkin = [new PetNoteModel(0, '', 0, 0, '', '', ''), new PetNoteModel(0, '', 0, 0, '', '', ''), new PetNoteModel(0, '', 0, 0, '', '', '')];;
                        this.pet_profile = [];
                        this.pet_refer = new PetReferModel(0, '', '', '', 0);
                        this.pet_visit = new PetVisitModel(0, '', '', '', '', '', '', '', '')
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProcsByPetId(pet_no: number) {
        const clinic_no = this.userData.clinic_no;
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getProcsByPetId?pet_no=${pet_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_procs = []
                        this.pet_procs = res.data.map((element) => {
                            return new PetProcsModel(element.tran_sequence, element.sup_sequence, element.link_no, element.link_type, element.item_type, element.unit, element.unit_cost, element.status, element.inv_date, element.req_date, element.appr_date, element.done_date, element.req_by, element.req_employee_initial, element.done_by, element.done_employee_initial, element.appr_by, element.appr_employee_initial, element.inv_by, element.inv_employee_initial, element.pstatus, element.tax, element.response1, element.response2, element.approval, element.chk_cost, element.cost, element.sub_cost, element.distr_method, element.route, element.start_time, element.moved, element.printed, element.recall_date, element.clinic_no, element.optional, element.rerequest, element.location, element.basechg, 0, 0, element.code_name, element.procedure_desc, element.pet_no, element.client_no, element.link_name, element.link_desc, element.link_fix, element.wtime, element.supervisor, element.attending, element.visible, element.dosage,element.days,element.altdays,element.frequency,element.indicationID,element.qty,element.notes,element.remain_times, element.dosage_unit, element.children);
                        });

                        resolve(1);
                    } else {
                        this.pet_procs = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetCheckIn() {
        this.pet_visit.pet_no = this.current_pet_no;
        this.pet_refer.pet_no = this.current_pet_no;
        this.pet_refer.refer_doctor = (this.pet_refer.refer_doctor === null || this.pet_refer.refer_doctor === undefined) ? '' : this.pet_refer.refer_doctor;
        this.pet_refer.refer_hospital = (this.pet_refer.refer_hospital === null || this.pet_refer.refer_hospital === undefined) ? '' : this.pet_refer.refer_hospital;
        this.pet_profile.forEach(element => {
            element.pet_no = this.current_pet_no;
        });
        this.pet_notes_checkin.forEach(element => {
            element.pet_no = this.current_pet_no;
            element.pet_name = (element.pet_name === null || element.pet_name === undefined) ? '' : element.pet_name;
        });

        var data = {
            pet_visit: this.pet_visit,
            pet_profile: this.pet_profile,
            pet_notes_checkin: this.pet_notes_checkin,
            pet_refer: this.pet_refer
        };

        console.log(this.pet_visit)

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetCheckIn`, data)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getEstimateProc(pet_no: string, status: string, client_no: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEstimateProc?pet_no=${pet_no}&status=${status}&clinic_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        const totalEst = res.data.totalEst;
                        resolve(totalEst);
                    } else {
                        this.pets = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    insertTreatmentProc(pet_no: string, time_code: string, request_date: string, start_date: Date, alt_days: string, request_times: string, remain_times: string, request_generate: boolean) {
        var data = {
            pet_no: pet_no,
            time_code: time_code,
            request_date: request_date,
            start_date: start_date,
            alt_days: alt_days,
            request_times: request_times,
            remain_times: remain_times,
            request_generate: request_generate,
        };

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/insertTreatmentProc?pet_no=` + pet_no + `&time_code=` + time_code + `&request_date=` + request_date + `&start_date=` + start_date + `&alt_days=` + alt_days + `&request_times=` + request_times + `&remain_times=` + remain_times + `&request_generate=` + request_generate)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    createTran() {
        // tmpTran.ClientNo = lngClientNo
        // tmpTran.PetNo = lngPetNo
        // tmpTran.LinkNo = intCodeNo
        // tmpTran.LinkType = intCodeType
        // tmpTran.LinkName = strCodeName
        // tmpTran.LinkDesc = GetLongName(intCodeNo, intCodeType)
        // tmpTran.Status = strStatus
        // tmpTran.ReqName = strReqEmp
        // tmpTran.ReqBy = intEmpNo
        // tmpTran.ReqDate = Now
        // tmpTran.SupSeq = 0
        // tmpTran.Cost = 0#
        // tmpTran.UnitCost = 0#
        // tmpTran.Unit = 1#
        // tmpTran.PStatus = False
        let promise = new Promise((resolve, reject) => {
            resolve(1)
        });
        return promise;
    }

    updateStatus() {
        // strSQL = "UPDATE tblTransaction SET status = " & QuoteSQL(strStatus)
        // If (strStatus = "W") Then
        //     strSQL = strSQL & ", start_time = '" & Now & "'"
        // End If
        // strSQL = strSQL & " WHERE tran_sequence = " & tmpTran.Seq
        let promise = new Promise((resolve, reject) => {
            resolve(1)
        });
        return promise;
    }

    tranDynOpt() {
        // strSQL = "UPDATE tblTransaction SET rerequest = "
        // If IsNull(tmpTran.IsRerequest) Or (Trim$(tmpTran.IsRerequest) = "") Then
        //     strSQL = strSQL & " 'N'" & ", optional = " & tmpTran.IsOptional
        // Else
        //     strSQL = strSQL & QuoteSQL(tmpTran.IsRerequest) & ", optional = 1"
        // End If
        // strSQL = strSQL & " WHERE tran_sequence = " & tmpTran.Seq
        let promise = new Promise((resolve, reject) => {
            resolve(1)
        });
        return promise;
    }

    getPriceChild(intParentCodeNo: number, intLinkNo: number, intLinkType: number) {
        // strSQL = "SELECT link_weight1, link_weight2, link_age1, link_age2, link_sex, link_specie, " _
        // & " link_rec_fix, link_dosage, link_chk_price, link_price " _
        // & "FROM tblLinksFile WHERE proc_no = " & intParentCodeNo _
        // & " AND link_no = " & intLinkNo & " AND link_type = " & intLinkType _
        // & " AND link_clinic = " & 1
        let promise = new Promise((resolve, reject) => {
            resolve(1)
        });
        return promise;
    }

    findFix(intCodeNo: number, intCodeType: number, strFix: string) {
        // strSQL = "SELECT code_fix FROM tblCodesFile WHERE code_no = " & intCodeNo & " AND code_type = " _
        // & intCodeType & " AND code_clinic = " & intClinicNo
        let promise = new Promise((resolve, reject) => {
            resolve(1)
        });
        return promise;
    }

    

    getRecallByClientOrPet(searchType: string, id: number) {
        let urlApi = `getRecallByClient?client_no=${id}`;

        if (searchType === 'pet') {
            urlApi = `getRecallByPet?pet_no=${id}`;
        } 

        let date = new Date();
        date.setDate(date.getDate() - 7);
        let strdate = date.toISOString().split('T')[0];

        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/${urlApi}&date=${strdate}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.pet_recalls = res.data.map((element) => {
                            return new RecallModel(element.pet_no, element.client_no, element.recall_sequence, element.recall_date, '', element.status_date, element.recall_doctor, element.recall_proc1, element.recall_proc2, element.recall_proc3, element.recall_note, element.recall_code, element.recall_status, false, element.pet_name, element.specie_name, element.weight, element.temperature, element.color_name, element.dob, element.sex, element.breed_name, element.client_name, element.email_address, element.age, element.pet_brief, element.recall_reason, element.recall_statusdesc,element.recall_statuscolor, false);
                        }); 
                        resolve(1);
                    } else {
                        this.pet_recalls = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetRecall() {
        this.pet_recall.pet_no = this.current_pet_no;
        this.pet_recall.client_no = this.clientService.current_client_no;
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetRecall`, this.pet_recall)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_recall = new RecallModel(0, 0, 0, '', '', '', '', '', '', '', '', '', '', false, '', '', 0, 0, '', '', '', '', '', '', 0, [], '', '', '', false);
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetEstimate() { 
        // this.pet_estimate.estimate_def = []
        // if (this.pet_estimate.items_by_category) {
        //     this.pet_estimate.items_by_category.forEach(element => {
        //         if (element.procs) {
        //             element.procs.forEach(t => {
        //                 this.pet_estimate.estimate_def
        //                     .push(new EstimateDefModel(t.estimate_def_sequence, element.category_no, t.code_no, t.code_type, Number(t.quantity), Number(t.price), t.defined));
        //             });
        //         }
        //     });
        // }

        console.log(this.pet_estimate)

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetEstimate`, this.pet_estimate)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        this.pet_estimates = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deletePetEstimate(item: EstimateModel) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletePetEstimate`, item)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        this.pet_estimates = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetEstimateGeneric() {
        // this.pet_estimate_generic.estimate_def = []
        // if (this.pet_estimate_generic.items_by_category) {
        //     this.pet_estimate_generic.items_by_category.forEach(element => {
        //         if (element.procs) {
        //             element.procs.forEach(t => {
        //                 this.pet_estimate_generic.estimate_def
        //                     .push(new EstimateDefModel(t.estimate_def_sequence, element.category_no, t.code_no, t.code_type, Number(t.quantity), Number(t.price), t.defined));
        //             });
        //         }
        //     });
        // }

        console.log(this.pet_estimate_generic)
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetEstimate`, this.pet_estimate_generic)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        //this.pet_estimates = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getEstimatesByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEstimatesByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        console.log("res.data", res.data);
                        this.pet_estimates = []
                        this.pet_estimates = res.data.filter((element) => element.pet_no != 0).map((element) => {
                            return new EstimateModel(element.estimate_sequence, element.pet_no, element.estimate_name, element.date_added, element._total_charge, element.estimate_note, []);
                        });
                        this.pet_generic_estimates = res.data.filter((element) => element.pet_no == 0).map((element) => {
                            return new EstimateModel(element.estimate_sequence, element.pet_no, element.estimate_name, element.date_added, element._total_charge, element.estimate_note, []);
                        });
                        resolve(1);
                    } else {
                        this.pet_estimates = [];
                        this.pet_generic_estimates = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetInfo() {
        this.pet.pet_no = this.current_pet_no;
        // this.pet.pet_code = `${this.pet.code1}${this.pet.code2}${this.pet.code3}${this.pet.code4}`;
        // console.log(`${this.pet.code1}${this.pet.code2}${this.pet.code3}${this.pet.code4}`);

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetInfo`, this.pet)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getProfileByPetId(pet_no: number, profile_type: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getProfileByPetId?pet_no=${pet_no}&profile_type=${profile_type}`)
                .subscribe((res: any) => {
                    if (res && res.data) {

                        switch (profile_type) {
                            case 1:
                                this.pet_profile_weight = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                                break;
                            case 2:
                                this.pet_profile_temp = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                                break;
                            case 4:
                                this.pet_profile_hr = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                                break;
                            case 6:
                                this.pet_profile_height = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                                break;
                            case 36:
                                this.pet_profile_bcs = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                                break;
                            case 5:
                                this.pet_profile_bp = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                                break;
                            case 3:
                                this.pet_profile_resp = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                            case 27:
                                this.pet_profile_fr = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                            case 29:
                                this.pet_profile_hydration = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                            case 31:
                                this.pet_profile_co2 = res.data.map((element) => {
                                    return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff);
                                });
                                break;
                        }

                        resolve(1);
                    } else {
                        switch (profile_type) {
                            case 1:
                                this.pet_profile_weight = [];
                                break;
                            case 1:
                                this.pet_profile_temp = [];
                                break;
                            case 36:
                                this.pet_profile_bcs = [];
                                break;
                            case 5:
                                this.pet_profile_bp = [];
                                break;
                            case 3:
                                this.pet_profile_resp = [];
                                break;
                        }
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getEnvironmentByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getEnvironmentByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_environment = new PetEnvironmentModel(res.data.pet_no, res.data.combo_index0, res.data.combo_index1, res.data.combo_index2, res.data.combo_index3, res.data.combo_index4, res.data.combo_index5, res.data.combo_index6, res.data.combo_index7, res.data.combo_index8, res.data.combo_index9, res.data.combo_index10, res.data.combo_index11, res.data.combo_index12, res.data.combo_index13, res.data.combo_index14)
                        resolve(1);
                    } else {
                        this.pet_environment = new PetEnvironmentModel(0, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getTagByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getTagByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_tag = new PetTagModel(res.data.pet_no, res.data.profile_sequence, res.data.chip_no, res.data.rabie_tag_no, res.data.rabie_vacc_date, res.data.license_no);
                        resolve(1);
                    } else {
                        this.pet_tag = new PetTagModel(0, 0, '', '', '', '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetRabie() {
        this.pet_tag.pet_no = this.current_pet_no;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetRabie`, this.pet_tag)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getAssociateByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getAssociateByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_associates = res.data.map((element) => {
                            return new PetAssociateModel(element.pet_no, element.last_name, element.first_name, element.middle_initial, element.associate_no, element.authority_id, element.authority_desc, element.associate_ownership);
                        });
                        resolve(1);
                    } else {
                        this.pet_associates = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetAssociate() {
        this.pet_associate.pet_no = this.current_pet_no;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetAssociate`, this.pet_associates)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    deletePetAssociate() {
        this.pet_associate.pet_no = this.current_pet_no;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletePetAssociate`, this.pet_associate)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getFullReferByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getFullReferByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_fullrefer = new PetFullReferModel(res.data.pet_no, res.data.by_refer_doctor, res.data.by_refer_hospital, res.data.by_refer_date, res.data.to_refer_doctor, res.data.to_refer_hospital, res.data.to_refer_date);
                        resolve(1);
                    } else {
                        this.pet_fullrefer = new PetFullReferModel(0, '', '', '', '', '', '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetRefer() {
        this.pet_associate.pet_no = this.current_pet_no;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetRefer`, this.pet_fullrefer)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getHistoriesByPetId(pet_no: number) {
        // Cancel any previous requests
        this.cancelHistoryRequests.next();
        
        // Store the pet number for this request to prevent race conditions
        const requestPetNo = pet_no;
        
        let promise = new Promise((resolve, reject) => {
            if (this.histories_page_number === 1)
                this.pet_histories = [];

            // Create a new Subject for this specific request
            const requestCancelled = new Subject<void>();
            
            // Store the current request's cancel subject
            const currentRequest = requestCancelled;
            
            // Set up the cancellation chain
            this.cancelHistoryRequests.subscribe(() => {
                currentRequest.next();
                currentRequest.complete();
            });

            this.api.get<SearchResult>(`${this.baseUrl}/getHistoriesByPetId?pet_no=${pet_no}&page_number=${this.histories_page_number}&order=${this.histories_order}`)
                .pipe(takeUntil(requestCancelled))
                .subscribe((res: any) => {
                    // Check if this request was cancelled
                    if (requestCancelled.closed) {
                        return;
                    }
                    
                    // Verify the pet_no matches the current pet before updating data
                    if (this.current_pet_no !== requestPetNo) { 
                        this.histories_page_number = 0;
                        return; // Don't update if pet has changed
                    }
                    
                    if (res && res.data) {
                        console.log('API Response for pet_no:', requestPetNo, res);
                        console.log('Prescriptions data from API:', res.data.prescriptions);
                        
                        this.pet_histories.push(...res.data.histories.map((element) => {
                            return new HistoryModel(element.history_sequence, element.sup_sequence, element.link_no, element.link_type, element.cost, element.ddate, element.done_date, element.inv_date, element.unit, element.req_by, element.req_employee_initial, element.appr_by, element.done_employee_initial, element.inv_by, element.inv_employee_initial, element.response1, element.response2, element.display, element.route, element.clinic_abbrev, element.location, element.invoice_no, element.procedure_desc, element.code_name, element.code_category, element.code_sub_category, element.category_name, element.subcategory_name, element.ticks_done_date, element.ticks_inv_date);
                        }));
                        this.pet_subhistories = res.data.subhistories.map((element) => {
                            return new SubHistoryModel(element.history_sequence, element.link_no, element.link_type, element.unit, element.procedure_desc, element.method_of_issue);
                        });
                        this.pet_suggestions = res.data.suggestions.map((element) => {
                            return new SuggestionsModel(element.suggest_date, element.link_no, element.link_type, element.procedure_desc);
                        });
                        this.pet_prescriptions = res.data.prescriptions.map((element) => {
                            return new PrescriptionsModel(element.drug_note_date, element.product_name, element.employee_initial, element.units, element.package, element.refill_count, element.refill_expire, element.allow_generic, element.in_clinic, element.instructions, element.drug_note_sequence, element.use_for, element.ticks_drug_note_date);
                        });
                        
                        console.log('Processed prescriptions:', this.pet_prescriptions);

                        if (res.data.histories) {
                            this.histories_page_number++;
                        }

                        resolve(1);
                    } else {
                        this.pet_histories = [];
                        this.pet_subhistories = [];
                        this.pet_suggestions = [];
                        this.pet_prescriptions = [];
                        resolve(0);
                    }
                }, (error) => {
                    if (!requestCancelled.closed) {
                        reject(error);
                    }
                });
        });
        return promise;
    }

    getMetabolicByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getMetabolicByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_metabolic = new PetMatabolicModel(res.data.pet_no, res.data.tag7, res.data.tag8, res.data.tag9, res.data.tag9bis, res.data.tag10, res.data.tag11, res.data.tag14, res.data.tag12, res.data.tag13, res.data.tag18, res.data.tag15, res.data.tag16, res.data.tag17, res.data.tag19, res.data.tag20, res.data.tag21, res.data.tag22, res.data.tag23, res.data.tag24, res.data.tag25);
                        resolve(1);
                    } else {
                        this.pet_metabolic = new PetMatabolicModel(0, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetMetabolic() {
        this.pet_metabolic.pet_no = this.current_pet_no;
        this.pet_metabolic._tag9 = this.pet_metabolic.tag9;
        this.pet_metabolic._tag9bis = this.pet_metabolic.tag9bis;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetMetabolic`, this.pet_metabolic)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetEnvironment() {
        this.pet_environment.pet_no = this.current_pet_no;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetEnvironment`, this.pet_environment)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getVitalsByPetId(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getVitalsByPetId?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_vitals = new PetVitalsModel(res.data.pet_no,res.data.tag0, res.data.tag3, res.data.tag4, res.data.tag5, res.data.tag2, res.data.tag30, res.data.tag31, res.data.tag32, res.data.tag33, res.data.tag34, res.data.tag26, res.data.tag26bis, res.data.tag27, res.data.tag27bis, res.data.tag28, res.data.tag28bis, res.data.tag29,  res.data.tag37, res.data.tag38, res.data.tag39, res.data.tag40, res.data.tag41, res.data.tag42, res.data.tag43, res.data.tag44, res.data.tag45, res.data.tag46, res.data.tag47);
                        resolve(1);
                    } else {
                        this.pet_vitals = new PetVitalsModel(0,'' ,'', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '','','');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetVitals() {
        this.pet_vitals.pet_no = this.current_pet_no;
        this.pet_vitals._tag26 = this.pet_vitals.tag26;
        this.pet_vitals._tag26bis = this.pet_vitals.tag26bis;
        this.pet_vitals._tag27 = this.pet_vitals.tag27;
        this.pet_vitals._tag27bis = this.pet_vitals.tag27bis;
        this.pet_vitals._tag28 = this.pet_vitals.tag28;
        this.pet_vitals._tag28bis = this.pet_vitals.tag28bis;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetVitals`, this.pet_vitals)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetDental() {
        this.pet_dental.pet_no = this.current_pet_no;
        this.pet_dental.username = this.userData.employee_name;
        // this.pet_dental.tooth_problem.push(...this.pet_tooths);

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetDental`, this.pet_dental)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetBrief() {
        this.pet_brief.pet_no = this.current_pet_no;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetBrief`, this.pet_brief)
                .subscribe((res: any) => {
                    if (res && res.result) {
                        resolve(res.result);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getSearchPatient(tag: string, patientName: string, specie: string, location: string, status: string, pet_no: number, client_no: number, PageNumber: number, tenant_no: number = 0) {

        let clinic_no = 0;
        if (!tenant_no) tenant_no = this.userData.tenant_no || 0;

        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getSearchPatient?clinic_no=${clinic_no}&tag=${tag}&patientName=${patientName}&specie=${specie}&location=${location}&status=${status}&pet_no=${pet_no}&client_no=${client_no}&PageNumber=${PageNumber}&tenant_no=${tenant_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.pet_patient = [];
                        this.pet_patient.push(...res.data.map((element) => {
                            return new PetPatientModel(element.tag_no, element.pet_no, element.pet_name, element.owner, element.first_name, element.last_name, element.specie_name, element.breed_name, element.specie, element.client_no,element.location,element.sublocation,element.status);
                        }));
                        //console.log(res)
                        //this.pet_patientsingle = new PetPatientModel(res.data[0].tag_no, res.data[0].pet_no, res.data[0].pet_name, res.data[0].owner, res.data[0].first_name, res.data[0].last_name, res.data[0].specie_name, res.data[0].breed_name, res.data[0].specie, res.data[0].client_no);
                        resolve(1);
                    } else {
                        //this.pet_patient = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getSearchPatientbyPet_no(tag: string, patientName: string, specie: string, location: string, status: string, pet_no: number, client_no: number, PageNumber: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getSearchPatient?tag=${tag}&patientName=${patientName}&specie=${specie}&location=${location}&status=${status}&pet_no=${pet_no}&client_no=${client_no}&PageNumber=${PageNumber}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.pet_patientsingle = new PetPatientModel(res.data[0].tag_no, res.data[0].pet_no, res.data[0].pet_name, res.data[0].owner, res.data[0].first_name, res.data[0].last_name, res.data[0].specie_name, res.data[0].breed_name, res.data[0].specie, res.data[0].client_no, res.data[0].location, res.data[0].sublocation,res.data[0].status);
                        resolve(1);
                    } else {
                        this.pet_patientsingle = new PetPatientModel('', '', '', '', '', '', '', '', '', '','','','');
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPetNotesByID(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getPetNotesByID?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        //console.log(res.results) 
                        this.pet_notes = res.data.map((element) => {
                            return new PetNoteModel(element.note_sequence, element.pet_name, element.pet_no, element.note_type, element.note_text, element.type_desc, element.note_date);
                        });
                        resolve(1);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    setupPetNote() {
        this.pet_vitals.pet_no = this.current_pet_no;
        this.pet_vitals._tag26 = this.pet_vitals.tag26;
        this.pet_vitals._tag26bis = this.pet_vitals.tag26bis;
        this.pet_vitals._tag27 = this.pet_vitals.tag27;
        this.pet_vitals._tag27bis = this.pet_vitals.tag27bis;
        this.pet_vitals._tag28 = this.pet_vitals.tag28;
        this.pet_vitals._tag28bis = this.pet_vitals.tag28bis;

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupPetNote`, this.pet_vitals)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getPetById(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getPetById?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        //console.log(res.data)
                        //this.pets = res.data.map((element) => { 
                        //return new PetDetailModel(element.pet_no,0, element.pet_name, element.weight, element.sex, element.dob, element.neuter, element.rabieDate, element.active, element.temperature, element.height, element.pet_code, element.picture, element.breed_name, element.color_name, element.specie_name, element.breed, element.color, element.specie, element.tag_no, false, element.age);
                        //}); 
                        this.pet_detail = new PetDetailModel(res.data.pet_no, res.data.client_no, res.data.pet_name, res.data.weight, res.data.sex, res.data.dob, res.data.neuter, res.data.rabieDate, res.data.active, res.data.temperature, res.data.height, res.data.pet_code, res.data.pictureFullUrl, res.data.breed_name, res.data.color_name, res.data.specie_name, res.data.breed, res.data.color, res.data.specie, res.data.tag_no, false, res.data.age, res.data.blood_pressure, res.data.rabies, res.data.chip_no, res.data.assigned_doctor);
                        resolve(this.pet_detail);
                    } else {
                        this.pets = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetNotesByClientId(client_no: number) {
        this.pet_notes = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl2}/GetNotesByClientId?client_no=${client_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        //console.log(res.results) 
                        this.pet_notes = res.data.map((element) => {
                            return new PetNoteModel(element.note_sequence, element.pet_name, element.pet_no, element.note_type, element.note_text, element.type_desc, element.note_date);
                        });
                        resolve(1);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    AddPetInfo() {
        this.pet.pet_no = this.current_pet_no;
        // this.pet.pet_code = `${this.pet.code1}${this.pet.code2}${this.pet.code3}${this.pet.code4}`;
        // console.log(`${this.pet.code1}${this.pet.code2}${this.pet.code3}${this.pet.code4}`);
        //?pet_no=${this.pet.pet_no}&pet_name=${this.pet.pet_name}&specie=${this.pet.specie}&active=${this.pet.active}&pet_code=${this.pet.pet_code}&dob=${this.pet.dob}&breed=${this.pet.breed}&color=${this.pet.color}&sex=${this.pet.sex}&weight=${this.pet.weight}&height=${this.pet.height}&temperature=${this.pet.temperature}&client_no=${this.pet.client_no}&picture=${this.pet.picture}&neuter=${this.pet.neuter}`

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/AddPetInfo`, this.pet)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetPetProfileLastEntry(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetProfileLastEntry?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        this.pet_profile_lastentry = new PetProfileLastEntryModel(res.data.body_score, res.data.body_score_date, res.data.weight, res.data.weight_date, res.data.temp, res.data.temp_date);
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }


    CheckPetTranRecords(pet_no: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/CheckPetTranRecords?pet_no=${pet_no}`)
                .subscribe((res: string) => {
                    resolve(res);
                }, (error) => {
                    reject(error);
                });
        });
    }

    CheckPetHistoryClinic(pet_no: string): Promise<string> {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/checkPetHistoryClinic?pet_no=${pet_no}`)
                .subscribe((res: string) => {
                    resolve(res);
                }, (error) => {
                    reject(error);
                });
        });
    }

    DeletePet(pet_no: number, username: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletePet?pet_no=${pet_no}&username=${username}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    PetMoveClient(pet_no: number, pet_name: string, client_to: number, client_from: number, username: string) {
        let vpetname = encodeURIComponent(pet_name);
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/petMoveClient?pet_no=${pet_no}&pet_name=${vpetname}&client_to=${client_to}&client_from=${client_from}&username=${username}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetTagNo(tag_no: string) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetTagNo?tag_no=${tag_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    }

    SetupTagNo(id: number, tag_no: string, pet_no: number, pet_name: string, location: string, sublocation: number, duration: number, date: string, status: string, department: string) {
        const clinic_no = this.userData.clinic_no; 
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupTagNo?id=${id}&tag_no=${tag_no}&pet_no=${pet_no}&pet_name=${pet_name}&location=${location}&sublocation=${sublocation}&duration=${duration}&date=${date}&status=${status}&department=${department}&clinic_no=${clinic_no}&done_by=${this.userData.employee_name}`)
                .subscribe(
                    (res: any) => {
                        if (res && res.data) {
                            resolve(res.data); 
                        } else {
                            resolve(0);
                        }
                    },
                    (error) => {
                        reject(error);
                    }
                );
        }); 
        return promise;
    }

    GetPetTagList(tag_no: string, pet_no: number, pet_name: string) {
        this.pet_notes = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetTagList?tag_no=${tag_no}&pet_no=${pet_no}&pet_name=${pet_name}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.pet_tag_list = res.data.map((element) => {
                            return new PetTagListModel(element.tag_no, element.pet_no, element.pet_name, element.location, element.sublocation, element.department, element.done_by);
                        });
                        resolve(1);
                    } else {
                        this.pet_tag_list = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    checkPetCheckInExist(pet_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/checkPetCheckInExist?pet_no=${pet_no}`)
                .subscribe((res: any) => { 
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    }

    GetPetVisit(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetVisit?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_visit2 = new PetVisitModel(res.data.pet_no, res.data.discharge_time, res.data.discharge_time_extra, res.data.assigned_doctor, res.data.supervising_doctor, res.data.clinic_dept, res.data.invoice_limit, res.data.assigned_nurse1, res.data.assigned_nurse2, res.data.assigned_doctor_name, res.data.supervising_doctor_name, res.data.assigned_nurse1_name, res.data.assigned_nurse2_name);
                        resolve(1);
                    } else {
                        this.pet_visit2 = new PetVisitModel(0, '', '', '', '', '', '', '', '')
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getCurrentDateTime() {
        const currentDate = new Date();

        const year = currentDate.getFullYear();
        const month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // Month is 0-indexed
        const day = ('0' + currentDate.getDate()).slice(-2);
        const hours = ('0' + currentDate.getHours()).slice(-2);
        const minutes = ('0' + currentDate.getMinutes()).slice(-2);
        const seconds = ('0' + currentDate.getSeconds()).slice(-2);

        const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.000`;
        return formattedDate;
    }

    getCurrentDate() {
        const currentDate = new Date();

        const year = currentDate.getFullYear();
        const month = ('0' + (currentDate.getMonth() + 1)).slice(-2); // Month is 0-indexed
        const day = ('0' + currentDate.getDate()).slice(-2);

        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    }

    SetupPetProfile(pet_no: number, profile_date: string, profile_type: number, profile: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupPetProfile?pet_no=${pet_no}&profile_date=${profile_date}&profile_type=${profile_type}&profile=${profile}&staff=${this.userData.employee_name}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupHospitalInstr(pet_no: number, note_text: string, notedate: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupHospitalInstr?pet_no=${pet_no}&note_text=${note_text}&notedate=${notedate}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetHospitalInstr(pet_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetHospitalInstr?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    }

    setupPhoto(files: LoadDocumentModel) {
        console.log(files);
        let promise = new Promise((resolve, reject) => {
            console.log(JSON.stringify(files));

            this.api.post(`${this.baseUrl}/setupPhoto`, files)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise; 
    }

    GetAdmittedPets(clinic_no) {
        let NullValue: string ="";
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetAdmittedPets?clinic_no=${clinic_no}&tenant_no=${this.userData.tenant_no}&Pet_Name=${NullValue}&ClientName=${NullValue}&CheckIn=${NullValue}&Doctor=${NullValue}&Nurse=${NullValue}&Tag_Date=${NullValue}&location_id=0&sublocation_id=0`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.admitted_pets = res.data.map((element) => {
                            let taggeddate = this.ConvertTagNoteToDate2(element.tagdate)
                            const dept = String(element.department || element.clinic_dept || element.sub_location || '').trim();
                            return new AdmittedPetsModel(element.tag_no, element.pet_no, element.pet_name, element.checkedin, element.client_no, element.first_name, element.last_name, element.assigned_doctor, element.assigned_nurse1, taggeddate, element.location, dept);
                        });
                        resolve(1);
                    } else {
                        this.admitted_pets = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    GetAdmittedPetsSearch(clinic_no, Pet_Name:string, ClientName:string, CheckIn:string, Doctor:string, Nurse:string, Tag_Date:string, location_id:number, sublocation_id:number) {
        let promise = new Promise((resolve, reject) => {
             this.api.get<SearchResult>(`${this.baseUrl}/GetAdmittedPets?clinic_no=${clinic_no}&tenant_no=${this.userData.tenant_no}&Pet_Name=${Pet_Name}&ClientName=${ClientName}&CheckIn=${CheckIn}&Doctor=${Doctor}&Nurse=${Nurse}&Tag_Date=${Tag_Date}&location_id=${location_id || 0}&sublocation_id=${sublocation_id || 0}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        this.admitted_pets = res.data.map((element) => {
                            let taggeddate = this.ConvertTagNoteToDate2(element.tagdate)
                            const dept = String(element.department || element.clinic_dept || element.sub_location || '').trim();
                            return new AdmittedPetsModel(element.tag_no, element.pet_no, element.pet_name, element.checkedin, element.client_no, element.first_name, element.last_name, element.assigned_doctor, element.assigned_nurse1, taggeddate, element.location, dept);
                        });
                        resolve(1);
                    } else {
                        this.admitted_pets = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    getRecallGeneral(begin_recall_date: string, end_recall_date: string) {
        this.pet_recalls = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getRecallGeneral?begin_recall_date=${begin_recall_date}&end_recall_date=${end_recall_date}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {
                        // this.pet_recalls = res.data.map((element) => {
                        //     return new RecallModel(element.pet_no, element.client_no, element.recall_sequence, element.recall_date, element.recall_req_date, element.status_date, element.recall_doctor, element.recall_proc1, element.recall_proc2, element.recall_proc3, element.recall_note, element.recall_code, element.recall_status, false, element.pet_name, element.specie_name, element.weight, element.temperature, element.color_name, element.dob, element.sex, element.breed_name, element.client_name, element.email_address, element.age, element.pet_brief);
                        // });
                        this.pet_recalls.push(...res.data)
                        resolve(res.results);
                    } else {
                        this.pet_recalls = [];
                        resolve(res.results);
                    }
                });
        });
        return promise;
    }

    changeRecallStatus(recallModel: any) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/changeRecallStatus`, recallModel)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    setupRecallLog(recallModel: any) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/setupRecallLog`, recallModel)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    ConvertTagNoteToDate(tagNote): Promise<string> {
        return new Promise((resolve) => {
            const datePattern = /(\d{1,2}\/\d{1,2}\/\d{2,4} \d{1,2}:\d{2}:\d{2} [APap][Mm])/;
            const matches = tagNote.match(datePattern);

            if (matches) {
                const dateTimeString = matches[0];
                const parsedDate = new Date(dateTimeString);
                const formattedDate = parsedDate.toLocaleString();
                resolve(formattedDate);
            } else {
                resolve(''); // Resolve with an empty string if no date is found
            }
        });
    }

    ConvertTagNoteToDate2(tagNote) {
        if (tagNote == undefined || tagNote == '' || tagNote == null) {
            return ''
        }

        const datePattern = /(\d{1,2}\/\d{1,2}\/\d{2,4} \d{1,2}:\d{2}:\d{2} [APap][Mm])/;
        const matches = tagNote.match(datePattern);

        if (matches) {
            const dateTimeString = matches[0];
            const parsedDate = new Date(dateTimeString);
            const formattedDate = parsedDate.toLocaleString();
            return (formattedDate);
        } else {
            return (''); // Resolve with an empty string if no date is found
        }
    }

    GetPetTagHistbyPetNo(pet_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetPetTagHistbyPetNo?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                    this.pet_tag_hist = res.data.map((element) => {
                        return new PetTagHistModel(element.id, element.tag_no, element.pet_no, element.pet_name, element.client_no, element.assign_date, element.done_date, element.location, element.sublocation, element.duration, element.status, element.department, element.done_by);
                    });
                }, (error) => {
                    reject(error);
                });
        });
    }

    getGenericEstimates() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`catalog/?type=${4}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.generic_estimates = res.data.map((element) => {
                            return new GenericEstimateModel(element.estimate_sequence, element.estimate_name, element.date_added, element.total_charge);
                        });
                        resolve(1);
                    } else {
                        this.generic_estimates = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    UpdateTranUnitCost(unit: number, cost: number, tran_sequence: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdateTranUnitCost?unit=${unit}&cost=${cost}&tran_sequence=${tran_sequence}`)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    async generateNextCode(existingCode: string): Promise<string> {
        const tagExists = await this.GetTagNo(existingCode);

        if (!tagExists) {
            return existingCode;
        }

        const lastChar = existingCode.charAt(existingCode.length - 1);
        let toreturn = '';

        if (!isNaN(parseInt(lastChar, 10))) {
            // Last character is a number, add 'b' and return 
            toreturn = existingCode + 'b';
        } else if (lastChar >= 'a' && lastChar <= 'z') {
            // Last character is a lowercase letter, increment and return
            const newChar = String.fromCharCode(lastChar.charCodeAt(0) + 1);
            toreturn = existingCode.slice(0, -1) + newChar;
        } else {
            // Last character is something else, add 'a' and return
            toreturn = existingCode + 'a';
        }

        return this.generateNextCode(toreturn); // Recursive call
    }

    GetPetTagHistbyPetNoDate(pet_no: number, assign_date: string) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetPetTagHistbyPetNoDate?pet_no=${pet_no}&assign_date=${assign_date}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    }

    GetCurrentPetTag(pet_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetCurrentPetTag?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
    }

    GetLastPetTagbyPetNo(pet_no: number) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetLastPetTagbyPetNo?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pettaghist_data = new PetTagHistModel(res.data.id, res.data.tag_no, res.data.pet_no, res.data.pet_name, res.data.client_no, res.data.assign_date, res.data.done_date, res.data.location, res.data.sublocation, res.data.duration, res.data.status, res.data.department, res.data.done_by);
                         
                        resolve(this.pettaghist_data);
                    } else {
                        this.pettaghist_data = new PetTagHistModel(0,'',0,'',0,'','','',0,0,'','','');
                        resolve(this.pettaghist_data);
                    }
                }, (error) => {
                    reject(error);
                });
        });
    }

    getEstimatesDetail(estimate_def_sequence: number, clinic_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetEstimatesDetail?estimate_def_sequence=${estimate_def_sequence}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.pet_estimate.estimate_def = res.data.map((element) => {
                            return new EstimateDefModel(element.estimate_def_sequence, element.dept_estimate_sequence, 
                                element.link_no, element.link_type, element.link_count, element.link_cost, element.defined, 
                                element.status, element.code_name, element.procedure_desc, element.code_category, element.type);
                        });
                        resolve(1);
                    } else {
                        this.pet_estimate.estimate_def = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    getPetNote(pet_no: number, note_type: number, startDate: string, endDate: string) {
        this.pet_notes = [];
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetNote?pet_no=${pet_no}&note_type=${note_type}&startDate=${startDate}&endDate=${endDate}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        this.pet_notes = res.data.map((element) => {
                            return new PetNoteModel(element.note_sequence, element.pet_name, element.pet_no, element.note_type, element.note_text, element.type_desc, element.note_date);
                        });
                        resolve(1);
                    } else {
                        this.pet_notes = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }  
    
    getPetTreatmentPlan( pet_no:number, clinic_no:number) {
        return new Promise((resolve, reject) => {
            this.api.get<string>(`${this.baseUrl}/GetPetTreatmentPlan?pet_no=${pet_no}&clinic_no=${clinic_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) { 
                        this.pet_treatment_plan = res.data.map((element) => {
                            return new PetTreatmentPlanModel(element.tran_sequence,element.pet_no,element.code_no,element.link_no,element.link_type,element.unit,element.unit_cost,
                                element.req_date,element.appr_date,element.done_date,element.code_name,element.code_category,element.category_name,element.procedure_desc,
                                element.req_by, element.request_date, element.start_date, element.alt_days, element.request_generate, element.request_times, element.remain_times, element.remarks);                       
                        });
                        resolve(1);
                    }
                }, (error) => {
                    reject(error);
                });
        });
    }

    setupTreatmentDets(request_sequence, remarks){
        let promise = new Promise((resolve, reject) => {
            this.api.post<string>(`${this.baseUrl}/SetupTreatmentDets?request_sequence=${request_sequence}&remarks=${remarks}`)
                .subscribe((res: any) => {
                    resolve(res.data);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    setupNote(){
        let promise = new Promise((resolve, reject) => {
            this.api.post<string>(`${this.baseUrl}/SetupNote`, this.note)
                .subscribe((res: any) => {
                    resolve(res);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    getNote(pet_no: number, client_no: number, begin: string, end: string) {
        let promise = new Promise((resolve, reject) => {    
            this.api.get<SearchResult>(`${this.baseUrl}/getNote?pet_no=${pet_no}&client_no=${client_no}&begin=${begin}&end=${end}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.notes = res.data.map((element) => {
                            return new NoteModel(element.note_sequence, element.pet_no, element.notedate, element.notetext, element.notetype_list, element.editable);
                        });
                        resolve(1);
                    } else {
                        this.pet_estimate.estimate_def = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    getNotePaginated(pet_no: number, client_no: number, page_number: number, page_size: number, begin: string = '', end: string = '', note_text: string = '', note_type: number = 0) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getNotePaginated?pet_no=${pet_no}&client_no=${client_no}&begin=${begin}&end=${end}&page_number=${page_number}&page_size=${page_size}&note_text=${note_text}&note_type=${note_type}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        const items = res.data.map((element) => {
                            return new NoteModel(element.note_sequence, element.pet_no, element.pet_name, element.notedate, element.notetext, element.notetype_list, element.editable);
                        });
                        resolve({ items, hasMore: (res.results ? res.results > 0 : items.length > 0) });
                    } else {
                        resolve({ items: [], hasMore: false });
                    }
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }

    GetLabTestList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetLabTestList`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.lab_test = res.data
                        resolve(1);
                    } else {
                        this.lab_test = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    getLabNameList(lab_test: string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getLabNameList?lab_test=${lab_test}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.lab_name = res.data.map((element) => {
                            return new LabNameModel(element.test_desc, element.seq_no);
                        });
                        resolve(1);
                    } else {
                        this.lab_name = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    getLoadTest( specie:number, lab_test:string, fseq_no:number, lseq_no:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getLoadTest?specie=${specie}&lab_test=${lab_test}&fseq_no=${fseq_no}&lseq_no=${lseq_no}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        this.load_test = res.data.map((element) => {
                            return new LoadTestModel(element.low, element.high, element.test_code, element.test_desc, element.result_length, element.unit, element.seq_no);
                        });
                        resolve(1);
                    } else {
                        this.load_test = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 
 
    //#region Image capture
    tempfiles: FileItemModel[] = [];
    setupImages(files: FileItemModel) { 
        let imagesdata = {
            image_name: files.fileName,
            image_data: files.value,
            image_type: files.fileType, 
        }
        let promise = new Promise((resolve, reject) => {
            console.log(JSON.stringify(files));

            this.api.post(`${this.baseUrl}/setupImages`, imagesdata)
            .subscribe((res: any) => {
                this.tempfiles = [];
                resolve(res.data);
            });
        });
        return promise; 
    }
  
    getImage(id: number) { 
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetImage?id=${id}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {  
                        let imageBase64 = `data:image/png;base64,${res.data}`;
                        resolve(imageBase64);
                    } else { 
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    SetupAssignImage(image_id:number, id:number, to:string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupAssignImage?image_id=${image_id}&id=${id}&to=${to}`)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    //SetupPicture(int PetNo, string PicPath, int? ParentPicId, string PicType, int EmpNo, int ZoomPct, int image_id, string PicNote, int PicComSeq)
    SetupPicture(pet_no:number, pic_path:string, parent_pic_id:number, pic_type:string, emp_no:number, zoom_pct:number, image_id:number, pic_note:string) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupPicture?PetNo=${pet_no}&PicPath=${pic_path}&ParentPicId=${parent_pic_id}&PicType=${pic_type}&EmpNo=${emp_no}&ZoomPct=${zoom_pct}&image_id=${image_id}&PicNote=${pic_note}`)
                .subscribe((res: any) => {
                    resolve(1); 
                });
        });
        return promise;
    }

    //GetGalleryPictures(int PetNo, int PicType)
    GetGalleryPictures(pet_no:number, pic_type:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetGalleryPictures?PetNo=${pet_no}&PicType=${pic_type}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {  
                        this.gallery_pictures = res.data.map((element) => {
                            //PicId	PetNo	DateTaken	PicPath	ParentPicId	PicType	EmpNo	ZoomPct	image_id	PicNote	EmpNo	image_bidata
                            return new GalleryPicturesModel(element.PicId, element.PetNo, element.DateTaken, element.PicPath, element.ParentPicId, element.PicType, element.EmpNo, element.ZoomPct, element.image_id, element.PicNote, `data:image/png;base64,${element.image_bidata}`, element.username);
                        });
                        resolve(1);
                    } else { 
                        this.gallery_pictures = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    }
    //#endregion


    //region Save PDF

    uploadReport(file: File, reportName: string, pet_no?: number, client_no?: number, type?: string) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('reportName', reportName);
        if (pet_no) formData.append('pet_no', pet_no.toString());
        if (client_no) formData.append('client_no', client_no.toString());
        if (type) formData.append('type', type);

        console.log('get pass here')
     
        let promise = new Promise((resolve, reject) => {
            this.api.post<string>(`${this.baseUrl}/saveReport`, formData)
                .subscribe((res: any) => {
                    resolve(res);
                }, (error) => {
                    reject(error);
                });
        });
        return promise;
    }


    //#endregion
 
    //SetupDoctorNurse(int pet_no, string? assigned_doctor, string? supervising_doctor, string? assigned_nurse1, string? assigned_nurse2)
    SetupDoctorNurse(pet_no:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupDoctorNurse?pet_no=${pet_no}&assigned_doctor=${this.pet_visit2.assigned_doctor}&supervising_doctor=${this.pet_visit2.supervising_doctor}&assigned_nurse1=${this.pet_visit2.assigned_nurse1}&assigned_nurse2=${this.pet_visit2.assigned_nurse2}`)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }
     
    GetFilesByPet(pet_no:number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetFilesByPet?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {   
                        this.file_listing = res.data.map((element) => {
                            return new FileModel(element.ID, element.FILENAME, element.FILEDATA, element.CreatedDate, element.client_no, element.pet_no, element.type);
                        });
                        resolve(1);
                    } else { 
                        this.file_listing = [];
                        resolve(0);
                    }
                });
        });
        return promise;
    } 

    //SetupLabRecord([FromBody] string json)
    SetupLabRecord(record: LabRecordModel[]) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupLabRecord`, record)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    SetupLabRecordAntech(record: LabRecordModel[]) {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupLabRecordAntech`, record)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    } 

    GetLabRecordByPetNo(pet_no:number, test_code:string) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetLabRecordByPetNo?pet_no=${pet_no}&test_code=${test_code}`)
                .subscribe((res: any) => {
                    if (res && res.results > 0) {   
                        let toreturn = res.data.map((element) => { 
                            return new LabRecordModel(element.labtest_id, element.pet_no, element.labtest_val, element.test_code, element.test_desc, element.labtest_date, element.recordedby, element.units, element.range, element.comment);                            
                        });

                        this.labrecord_tables.push({
                            test_code: test_code,
                            table: toreturn
                        });
                        resolve(toreturn);
                    } else {   
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    // DeleteNote(int seq, string table)
    DeleteNote(seq: number, types: number[]) {
        let table: string = '';

        for (const item of types) {
            if (item < 37) {
                table = 'tblNote';
            } else {
                return Promise.reject('This type of note cannot be deleted.');
            }
        }

        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/deletenote?seq=${seq}&table=${table}`)
                .subscribe((res: any) => {
                    if (res && res.data) {
                        resolve(1);
                    } else {
                        resolve(0);
                    }
                });
        });
        return promise;
    }

    SetupPetAssociate() {
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/SetupPetAssociate`, this.pet_associates)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    //getpetrabiedetails
    GetPetRabieDetails(pet_no: number) {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/GetPetRabieDetails?pet_no=${pet_no}`)
                .subscribe((res: any) => {
                    if(res && res.results > 0){
                        this.pet_rabie_details = new PetRabieDetailsModel(res.data.pet_no, res.data.rabie_tag_no, res.data.rabie_vacc_no, res.data.rabie_vacc_date, res.data.rabie_doctor, res.data.rabie_clinic, res.data.rabie_year, res.data.vaccine_no, res.data.vaccine_manuf, res.data.vaccine_type, res.data.vaccine_batch_no, res.data.vaccine_expire, res.data.vaccine_name, res.data.vaccine_active, res.data.vaccine_use, res.data.vaccine_clinic, res.data.doctor_desc, res.data.clinic_desc);
                    }
                    else{
                        this.pet_rabie_details = new PetRabieDetailsModel(0,'','','','',0,0,'','','','','','',false,'');
                    }
                    resolve(res);
                });
        });
        return promise;
    }

    getSimpleClientList() {
        let promise = new Promise((resolve, reject) => {
            this.api.get<SearchResult>(`${this.baseUrl}/getSimpleClientList`)
                .subscribe((res: any) => {
                    this.simple_pet_list = res.data.map((element) => {
                        return {pet_no: element.pet_no, pet_name: element.pet_name, client_no: element.client_no};
                    });
                    resolve(1);
                });
        });
    }

    GetTagNoLookup(type: number, number: string) {
        let promise = new Promise((resolve, reject) => {
            if(type == 1){
                this.api.get<SearchResult>(`${this.baseUrl}/GetTagNoLookup_1?number=${number}`)
                .subscribe((res: any) => { 
                    if(res && res.results > 0){
                        let toreturn: PetRabieModel[] = res.data.map((element) => {
                            return new PetRabieModel(element.pet_no, element.rabie_tag_no, element.rabie_vacc_no, element.rabie_vacc_date, element.rabie_doctor, element.rabie_clinic, element.rabie_year, element.clinic_abbrev, element.pet_name);
                        });
                        resolve(toreturn);
                    } 
                }); 
            }
            else if(type == 2){ 
                this.api.get<SearchResult>(`${this.baseUrl}/GetTagNoLookup_2?number=${number}`)
                .subscribe((res: any) => {
                    if(res && res.results > 0){
                        let toreturn: PetProfileModel[] = res.data.map((element) => {
                            return new PetProfileModel(element.profile_sequence, element.pet_no, element.profile_date, element.profile_type, element.profile, element.staff, element.pet_name);
                        });
                        resolve(toreturn);
                    }
                });
            } 
            else{
                this.api.get<SearchResult>(`${this.baseUrl}/GetTagNoLookup_3?number=${number}`)
                .subscribe((res: any) => {
                    if(res && res.results > 0){
                        let toreturn: PetTagListModel[] = res.data.map((element) => {
                            return new PetTagListModel(element.tag_no, element.pet_no, element.pet_name, element.location, element.sublocation, element.department, element.done_by);
                        });
                        resolve(toreturn);
                    }
                });
            }
        });

        return promise;
    }

    UpdatePetPicture(pet_no: number, picture_path: number){
        let promise = new Promise((resolve, reject) => {
            this.api.post(`${this.baseUrl}/UpdatePetPicture?pet_no=${pet_no}&picture_path=${picture_path}`)
                .subscribe((res: any) => {
                    resolve(1);
                });
        });
        return promise;
    }

    checkReservedPetTag(location: string, sublocation: number, target_date: string) {
        let promise = new Promise((resolve) => {
            this.api.get(`${this.baseUrl}/checkReservedPetTag?location=${location}&sublocation=${sublocation}&target_date=${target_date}`)
                .subscribe((res: any) => {
                    resolve(res);
                });
        });
        return promise;
    }




}